import { forwardRef } from 'react';
import { BaseTypeMap, Component, ComponentProps } from './types/Component';

type BoxTypeMap = BaseTypeMap<'div'>;

export type BoxProps = ComponentProps<BoxTypeMap>;

export const Box: Component<BoxTypeMap> = forwardRef(function Box(
  { as: Component = 'div', ...rest },
  ref
) {
  return <Component {...rest} ref={ref} />;
});
